import { render, staticRenderFns } from "./CourseNavigation.vue?vue&type=template&id=4aaf3e2c&scoped=true&"
import script from "./CourseNavigation.vue?vue&type=script&lang=ts&"
export * from "./CourseNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./CourseNavigation.vue?vue&type=style&index=0&id=4aaf3e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaf3e2c",
  null
  
)

export default component.exports